module.exports = __webpack_public_path__ + "static/media/2k_moon.833cdd47.jpg";